import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';

function isAdminShellPath(pathname) {
  return (
    pathname.startsWith('/admin') ||
    pathname === '/notificationAdmin' ||
    pathname.toLowerCase() === '/notificationadmin'
  );
}

/**
 * Renderiza Header/Footer da loja apenas fora das rotas do painel admin.
 */
export function AppChrome({ children }) {
  const { pathname } = useLocation();
  const hideStoreChrome = isAdminShellPath(pathname);

  return (
    <>
      {!hideStoreChrome && <Header />}
      {children}
      {!hideStoreChrome && <Footer />}
    </>
  );
}

export default AppChrome;
